import { ReactNode } from 'react'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

interface SettingItemProps {
  children: ReactNode,
  isChecked: boolean | undefined,
  secondaryText: string,
  title: string,
}
const SettingItem = (props: SettingItemProps) => {
  const {
    children, isChecked, secondaryText, title,
  } = props

  return (
    <DashboardModuleListItem
      isChecked={isChecked}
      showCheckbox
      title={title}
      secondaryText={secondaryText}
    >
      {children}
    </DashboardModuleListItem>
  )
}

export default SettingItem
